import React from "react";
import {
    Button,
    TextField,
    FormControlLabel,
    Checkbox,
    Box,
    Grid,
    makeStyles,
    CircularProgress
} from "@material-ui/core";
const useStyles = makeStyles(theme => ({
    main: {
        maxWidth: "100%",
        margin: "40px auto",
        borderRadius: "20px",
        border: "1px solid #00000050",
        background: "#fff",
        padding: "30px 30px"
    },
    heading: {
        fontSize: "1.25rem",
        fontWeight: "bold",
        maxWidth: "1000px",
        margin: "auto",
        fontFamily: "Roboto",
        textAlign: "center",
        marginBottom: "40px"
    },
    textField: {
        maxWidth: "100%",
        width: "100%",
        padding: "7px 0 0 7px",
        "& fieldset": {
            borderWidth: "0 0 1px 0 !important",
            borderRadius: "0"
        },
        "& input": {
            padding: "10px 1px 5px !important",
            minHeight: "21px !important"
        }
    },
    Buttons: {
        display: "flex",
        justifyContent: "flex-end",
        columnGap: "15px",
        maxWidth: "max-content",
        margin: "auto",
        marginTop: "20px"
    },
    gridContainer: {
        margin: "30px 0",
        width: "100%",
        rowGap: "20px"
    },
    "@media (max-width:680px) ": {
        main: {
            padding: "40px 16px"
        }
    },
    "@media (max-width:600px) ": {
        gridContainer: {
            rowGap: "10px"
        }
    },
    "@media (max-width:450px) ": {
        main: {
            padding: "20px 10px"
        }
    }
}));
export const PatientCustomQuestion = props => {
    const classes = useStyles();
    const { questions, handleChange, sendMail, errors, ids, formFields, handleTabChange, loading } = props;
    const filteredQuestions = questions.filter(question => ids.includes(question.id));

    return (
        <Box className={classes.main}>
            <h2 className={classes.heading}>Brugerdefinerede spørgsmål</h2>

            {/* {errors &&
                Object.values(errors).map((msg, index) => (
                    <p key={index} style={{ color: "red", margin: "0", fontFamily: "Roboto", lineHeight: "24px" }}>
                        {msg}
                    </p>
                ))} */}

            {/* New Questions Form */}

            <Box>
                <Grid container spacing={3} className={classes.gridContainer}>
                    {filteredQuestions.length > 0 &&
                        filteredQuestions.map(question => {
                            // const fieldValue =
                            //     formFields.find(field => field.clientFormFieldsId === question.id)?.fieldValue || "";
                            const isRequired = question.isRequired; // Adjust based on your data
                            const fieldValue =
                                (Array.isArray(formFields) &&
                                    formFields.find(field => field.clientFormFieldsId === question.id)?.fieldValue) ||
                                "";
                            return (
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={4}
                                    lg={3}
                                    key={question.id}
                                    display="flex"
                                    alignItems="center"
                                    gap={2}>
                                    {question.fieldType === "text" || question.fieldType === "number" ? (
                                        <TextField
                                            className={classes.textField}
                                            InputLabelProps={{ shrink: true }}
                                            label={`${question.fieldName}${isRequired ? " *" : ""}`}
                                            variant="outlined"
                                            name={question.fieldName}
                                            type={question.fieldType}
                                            value={fieldValue}
                                            onChange={e => handleChange(question.id, "fieldValue", e.target.value)}
                                            error={Boolean(errors[question.id])}
                                            helperText={errors[question.id] || ""}
                                        />
                                    ) : question.fieldType === "checkbox" ? (
                                        <>
                                            <FormControlLabel
                                                style={{ width: "100%", borderBottom: "1px solid rgba(0, 0, 0, 0.23)" }}
                                                control={
                                                    <Checkbox
                                                        checked={fieldValue || false}
                                                        onChange={e =>
                                                            handleChange(question.id, "fieldValue", e.target.checked)
                                                        }
                                                    />
                                                }
                                                label={
                                                    <span>
                                                        {question.fieldName}
                                                        {isRequired && <span style={{ color: "#f44336" }}> *</span>}
                                                    </span>
                                                }
                                            />
                                            {errors[question.id] && (
                                                <p
                                                    style={{
                                                        color: "#f44336",
                                                        margin: "0",
                                                        fontFamily: "Roboto",
                                                        fontSize: "12px",
                                                        marginLeft: "0 !important"
                                                    }}>
                                                    {errors[question.id]}
                                                </p>
                                            )}
                                        </>
                                    ) : null}
                                </Grid>
                            );
                        })}
                </Grid>
            </Box>
            <Box className={classes.Buttons}>
                <Button variant="contained" color="primary" onClick={() => handleTabChange("", 0)}>
                    Tilbage
                </Button>
                <Button variant="contained" color="primary" onClick={sendMail} disabled={loading}>
                    Indsend {loading && <CircularProgress size={24} />}
                </Button>
            </Box>
        </Box>
    );
};
